<template>
  <basic-content>
    <a-row slot="content">
      <manager />
    </a-row>
  </basic-content>
</template>

<script>
import BasicContent from '@/layout/BasicContent.vue'
import Manager from '@/com/Manager/Manager.vue'

export default {
  name: 'ManagerMain',
  data() {
    return {
      tab: 'man'
    }
  },
  components: {
    BasicContent,
    Manager
  },
  methods: {
  },
  created() {
    this.$store.commit('changetab', this.tab)
  }
}
</script>

<style scoped>
</style>

